import { Serializable } from './Serializable';

export class DepartmentDTO extends Serializable {
    id: string;
    name: string;
    parentId: string;
    parent: DepartmentDTO;
    usersQuantity: number;
    managersQuantity: number;
    
    constructor() {
        super();
    }

    get departmentName() {
        let name = '--';
        if (this.parent) {
            name = this.parent.name;
        }
        return name;
    }
    
}
